import axios from "axios";
import { getToken, logout } from "./authorize";

const apiBaseUrl = process.env.REACT_APP_API || "http://localhost:3002/api";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (config) => {
    const nextConfig = { ...config };
    const token = getToken();

    if (token) {
      nextConfig.headers = {
        ...nextConfig.headers,
        Authorization: nextConfig.headers?.Authorization || nextConfig.headers?.authorization || `Bearer ${token}`,
      };
    }

    if (typeof nextConfig.url === "string" && nextConfig.url.startsWith("/api/")) {
      nextConfig.url = `${apiBaseUrl.replace(/\/$/, "")}${nextConfig.url.replace(/^\/api/, "")}`;
    }

    return nextConfig;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      logout(() => {
        window.location.replace("/pages/signin");
      });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;